module.exports = __webpack_public_path__ + "static/portfoliopic-af4096f4586bfcc89309177f85aebecf.jpg";